import React from 'react';
import { Card as Bs5Card } from 'react-bootstrap5';

const Card = Bs5Card;

Object.assign(Card, {
  Header: Bs5Card.Header,
  Title: props => {
    // Cards do not have a title, therefore we return a simple div instead
    return <div {...props}>{props.children}</div>;
  },
  Body: Bs5Card.Body,
  Footer: Bs5Card.Footer
});

export default Card;
